import React, { useEffect, useState } from "react";
import classes from "./ExperienceExcellence.module.css";
import { Modal } from "antd";
import ReactPlayer from "react-player";
import ExperienceCarousel from "./ExperienceCarousel";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import AdjustFontSize from "../../../components/adjust-font-size/AdjustFontSize";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../App";
import { useContext } from "react";

const ExperienceExcellence = ({ data }) => {
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  // useEffect(() => {
  //   //html content will rearrange fontsize when window width changes
  //   if (data) {
  //     setResponsiveHtml(AdjustFontSize(data?.description, width));
  //   }
  // }, [data, width]);

  return (
    <>
      <div className={classes.outer} id="home-page-know-more">
        <div
          className={classes.left}
          data-aos="fade-right"
          data-aos-delay="200"
        >
          <span className={`bg-primary-200 primary-500 ${classes.subTitle}`}>
            {data?.subTitle}
          </span>
          <div className={classes.title}>
            <h3 dangerouslySetInnerHTML={{ __html: data?.title }}></h3>
          </div>
          <div className={classes.underLine}></div>
          {data?.description && (
            <p
              className={`description-content ${classes.description}`}
              dangerouslySetInnerHTML={{
                __html: data?.listingItems[0]?.homeDescription,
              }}
            ></p>
          )}
          <button
            className="primaryHover border-primary-500"
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              navigate(`/pages/${data?.listingItems[0]?.slug}`);
              setIsBackNavigation(true)
            }}
          >
            Know More About Sabine Groups
          </button>
        </div>
        <div
          className={classes.right}
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <ExperienceCarousel data={data} />
        </div>
      </div>
    </>
  );
};

export default ExperienceExcellence;
